import * as React from 'react';

import { smartGroupIllustrationSrc, } from '../shared/shared';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';

const UpgradeModal = ({ closeModal, buildAdminContactMailto, }) => {
  const { modalRef } = useModalAccessibility(closeModal);
  
  return (
    <div className="modal-container upgrade-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="upgradeModal"
        aria-modal="true"
        className="upgrade-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <img alt="" src={smartGroupIllustrationSrc} />
        <div className="title">
          <h2 id="upgradeModal">Turn Insights into Action, Instantly</h2>
        </div>
        <p>Imagine identifying a skill gap and assigning the perfect practice to the students who need it most, all with a single click, right from this report.</p>
        <p><b>This powerful time-saving feature is available with a School or District Premium plan.</b> It bridges the gap between data analysis and instruction, ensuring every student gets the precise support they need to grow.</p>
        <div className="buttons-wrapper">
          <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <div className="form-buttons">
            <a className="quill-button green outlined medium focus-on-light" href='/premium' rel="noopener noreferrer" target="_blank">Learn more about School & District Premium</a>
            <a className="quill-button green contained medium focus-on-light" href={buildAdminContactMailto()}>Contact your admin</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpgradeModal
